/* import user from '../../assets/testimonial/appdt.webp'; */

const data = [
  {
    id: 0,
    profileImg: 'dylan.webp',
    company: 'Freelancer',
    name: 'Dylan Angarita Diaz',
    level: 'Desarrollador Jr',
    work: 'Parking International S.A.S',
    date: 'Noviembre 2022 - Septiembre 2023',
    testimony: `Recomiendo encarecidamente a Alejandro Guzmán como desarrollador web y de software. Su experiencia técnica excepcional, enfoque meticuloso y habilidades de resolución de problemas lo convierten en un recurso valioso para cualquier proyecto. Alejandro es proactivo, colaborativo y siempre entrega resultados de alta calidad.`,
  },
  {
    id: 1,
    profileImg: 'Testimonio-Proximos.gif',
    company: '',
    name: '',
    level: '',
    work: 'Muy pronto!!!',
    date: '',
    testimony:
      '🌟 ¡Grandes noticias a la vista! 🌟 Estamos emocionados de compartir que pronto contaremos con una colección de testimonios que resaltan las habilidades y experiencias extraordinarias de nuestros colaboradores. 🚀 Estén atentos para conocer las historias de aquellos que han experimentado de primera mano el profesionalismo y la excelencia en nuestros servicios. ¡Agradecemos tu participación y esperamos compartir más éxitos juntos!',
  },
];
export default data;
